import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import '@shared/styles/tokens.css'
import '@shared/styles/base.css'
import '@shared/styles/components.css'
import './web.css'
import './theme.css'
// Sets the skin on <html> before anything is drawn.
import './theme'

import { ErrorBoundary } from '@shared/components'
import { AuthProvider } from '@shared/state/AuthContext'
import { SelectionProvider } from '@shared/state/SelectionContext'
import { App } from './App'

const container = document.getElementById('root')

if (!container) {
  // Should never happen; this keeps the failure readable if index.html breaks
  document.body.innerHTML =
    '<pre style="color:#fff;padding:24px;font-family:monospace">Missing #root element. Check index.html.</pre>'
} else {
  createRoot(container).render(
    <StrictMode>
      <ErrorBoundary label="WonderWorks">
        <BrowserRouter>
          <AuthProvider>
            <SelectionProvider>
              <App />
            </SelectionProvider>
          </AuthProvider>
        </BrowserRouter>
      </ErrorBoundary>
    </StrictMode>,
  )
}
